import { useGtm } from '@gtm-support/vue-gtm'

export const trackGtmEvent = (event) => {
	const gtm = useGtm()
	if (gtm && gtm.enabled()) {
		window.dataLayer?.push(event)
	}
}
